import { dayjs } from 'third-party';

export const formatChatMessageDate = (createdOn: string) =>
  dayjs(createdOn).format('h:mm A');
